import type { RouteObject } from "react-router-dom";
import { helperPathname, pathname } from "#src/config/pathname";

import { EndpointOverview } from "#src/pages/endpoint/overview";
import { EndpointDevices } from "#src/pages/endpoint/devices";
import HostDetailsLayout from "#src/pages/endpoint/devices/details/layout";
import HostOverview from "#src/pages/endpoint/devices/details/overview";
import HostSoftware from "#src/pages/endpoint/devices/details/software";
import HostPolicies from "#src/pages/endpoint/devices/details/policies";
import { HostDrive } from "#src/pages/endpoint/devices/details/drive";
import HostActivities from "#src/pages/endpoint/devices/details/activities";
import { EndpointPolicies } from "#src/pages/endpoint/policies";
import { EndpointPassports } from "#src/pages/endpoint/passports";
import { EndpointThreatPreventionWebsites } from "#src/pages/endpoint/threatPrevention/websites";
import { EndpointThreatPreventionIps } from "#src/pages/endpoint/threatPrevention/ips";
import { EndpointThreatPreventionPorts } from "#src/pages/endpoint/threatPrevention/ports";
import { DirectoryUsers } from "#src/pages/endpoint/directory/users";
import { DirectoryDepartments } from "#src/pages/endpoint/directory/departments";
import { DlpBackupSettings } from "#src/pages/endpoint/dlp/backupSettings";
import { DlpDataLabeling } from "#src/pages/endpoint/dlp/dataLabeling";
import { EndpointDlpExternalStorage } from "#src/pages/endpoint/dlp/externalStorage";

export const endpointRoute: RouteObject = {
  path: helperPathname.ENDPOINT,
  children: [
    {
      path: pathname.ENDPOINT_OVERVIEW,
      element: <EndpointOverview />,
    },
    {
      path: pathname.ENDPOINT_DEVICES,
      element: <EndpointDevices />,
    },
    {
      path: helperPathname.ENDPOINT_DEVICE_DETAIL,
      element: <HostDetailsLayout />,
      children: [
        {
          path: pathname.ENDPOINT_DEVICES_OVERVIEW,
          element: <HostOverview />,
        },
        {
          path: pathname.ENDPOINT_DEVICES_SOFTWARE,
          element: <HostSoftware />,
        },
        {
          path: pathname.ENDPOINT_DEVICES_POLICIES,
          element: <HostPolicies />,
        },
        {
          path: pathname.ENDPOINT_DEVICES_DRIVE,
          element: <HostDrive />,
        },
        {
          path: pathname.ENDPOINT_DEVICES_ACTIVITIES,
          element: <HostActivities />,
        },
      ],
    },
    {
      path: pathname.ENDPOINT_PASSPORTS,
      element: <EndpointPassports />,
    },
    {
      path: pathname.ENDPOINT_POLICIES,
      element: <EndpointPolicies />,
    },
    {
      path: helperPathname.ENDPOINT_THREAT_PREVENTION,
      children: [
        {
          path: pathname.ENDPOINT_THREAT_PREVENTION_WEBSITES,
          element: <EndpointThreatPreventionWebsites />,
        },
        {
          path: pathname.ENDPOINT_THREAT_PREVENTION_IPS,
          element: <EndpointThreatPreventionIps />,
        },
        {
          path: pathname.ENDPOINT_THREAT_PREVENTION_PORTS,
          element: <EndpointThreatPreventionPorts />,
        },
      ],
    },
    {
      path: helperPathname.ENDPOINT_DLP,
      children: [
        {
          path: pathname.ENDPOINT_DLP_BACKUP_SETTINGS,
          element: <DlpBackupSettings />,
        },
        {
          path: pathname.ENDPOINT_DLP_DATA_LABELING,
          element: <DlpDataLabeling />,
        },
        {
          path: pathname.ENDPOINT_DLP_EXTERNAL_STORAGE,
          element: <EndpointDlpExternalStorage />,
        },
      ],
    },
    {
      path: helperPathname.ENDPOINT_DIRECTORY,
      children: [
        {
          path: pathname.ENDPOINT_DIRECTORY_USERS,
          element: <DirectoryUsers />,
        },
        {
          path: pathname.ENDPOINT_DIRECTORY_DEPARTMENTS,
          element: <DirectoryDepartments />,
        },
      ],
    },
  ],
};
